import { InspectionFollowUpWorkflowStatusEnum } from '../../enum/inspection-follow-up-workflow-status.enum';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class InspectionFollowUpInstructionData {
  ScaffoldDiaryId: string;
  OwnerId: string;
  InspectionFollowUpWorkflowStatus: InspectionFollowUpWorkflowStatusEnum;
  RelatedInspectionId: string;
  Instructions: string;
  ToBeDoneBy: string;
  ActionToBeCarriedOutBy: string[];
}


